module.exports = __webpack_public_path__ + "static/img/visitwork.96392e2c.png";